import { maskElements, tagifyElements } from "./app"
import { getFirebaseAuthorizationHeaders, serverUrl, uploadFileToTemp } from "./server/advayta"
import { showErrorToast } from "./uiControl/toastControl"

let uploading = 0
const filesToDelete = [] // Глобальный массив для хранения файлов на удаление
const uploadedFiles = new Set()

export async function upload(event) {
    event.preventDefault()
    const title = document.getElementById('title')
    const date = document.getElementById('date')
    const type = document.getElementById('type')

    if (event.target.parentNode.querySelector('#website-link')) {
        if (!title.value || !date.value || !type.value) {
            showErrorToast('Перед загрузкой аудио необходимо заполнить поля Название, тип, дата')
            return false
        }
    }

    // const index = parseInt(event.target.dataset.index, 10);
    const fileInput = document.createElement('input')
    fileInput.type = 'file'
    // Находим кнопку с атрибутом data-accept
    const uploadButton = event.target.closest('button.file-upload')
    fileInput.accept = uploadButton ? uploadButton.getAttribute('data-accept') || '.mp3' : '.mp3'

    fileInput.addEventListener('change', async (fileEvent) => {
        const file = fileEvent.target.files[0]
        if (!file) return

        const inputElement = event.target.closest('.d-flex').parentNode.querySelector('input')
        const currentValue = inputElement.value

        // Находим кнопку загрузки и управляем её состоянием
        const uploadButton = event.target.closest('button.file-upload')
        const spinner = uploadButton.querySelector('.spinner-border')
        const icon = uploadButton.querySelector('i')

        try {
            // Если есть текущий файл, добавляем его в список на удаление
            if (currentValue) {
                filesToDelete.push(currentValue)
            }

            // Показываем спиннер, скрываем иконку
            spinner.classList.remove('d-none')
            icon.classList.add('d-none')

            const upload = await uploadFileToTemp(file)

            if (upload) {
                const fileUrl = `${serverUrl}/upload/${upload[0].name}`
                inputElement.value = fileUrl

                uploadedFiles.add(inputElement.id)
            } else {
                console.error('Ошибка при загрузке файла')
            }
        } catch (error) {
            alert('При загрузке файла произошла ошибка')
            console.error('Ошибка при загрузке файла:', error)
        } finally {
            // Скрываем спиннер, показываем иконку
            spinner.classList.add('d-none')
            icon.classList.remove('d-none')
        }
    })

    fileInput.click()
}

export async function deleteFile(event, immediate = false) {
    event.preventDefault()
    const inputElement = event.target.closest('.d-flex').parentNode.querySelector('input')
    if (!inputElement.value) return

    if (!immediate) {
        if (!confirm('Вы действительно хотите удалить файл?')) return
    }

    const path = inputElement.value

    if (immediate) {
        await deleteByPath(path)
    } else {
        filesToDelete.push(path)
    }

    inputElement.value = ''
}

export async function deleteByPath(path) {
    return await fetch(`${serverUrl}/api/file?path=${encodeURIComponent(path)}`, {
        method: 'DELETE',
        headers: await getFirebaseAuthorizationHeaders(),
    })
}

// Функция для обработки отложенного удаления файлов (вызывать перед сохранением)
export async function processFilesToDelete() {
    try {
        // Удаляем все файлы из списка
        await Promise.all(
            filesToDelete.map(path =>
                deleteByPath(path).catch(error =>
                    console.error(`Ошибка удаления файла ${path}:`, error))
            )
        )

        // Очищаем список
        filesToDelete.length = 0
    } catch (error) {
        console.error('Ошибка при обработке файлов для удаления:', error)
        throw error // Можно пробросить ошибку дальше для обработки
    }
}

export function wasFileUploaded(fieldId) {
    return uploadedFiles.has(fieldId)
}

export function clearUploadedFiles() {
    uploadedFiles.clear()
}

function parseFileName(fileName) {
    fileName = decodeURIComponent(fileName)
    fileName = fileName.replace('.', '')
    const parse = fileName.split(' ')
    console.log(parse)
    const date = `${parse[0]}.${parse[1]}.${parse[2]}`
    const type = parse[3]
    const title = parse[4]
    const titleFrom = fileName.indexOf(type) + type.length
    tagifyElements['type'].removeAllTags()
    tagifyElements['type'].addTags([type])
    maskElements.date.iMask.value = date
    document.getElementById('title').value = fileName.slice(titleFrom, fileName.length).split('.')[0]
}
